import { z } from 'zod';

export const B2bCampaignActionHandlerValues = ['company', 'distributor'] as const;
export const ZodB2bCampaignActionHandler = z.enum(B2bCampaignActionHandlerValues);
export type B2bCampaignActionHandler = z.TypeOf<typeof ZodB2bCampaignActionHandler>;
